module.exports = __webpack_public_path__ + "startpage-746fed5a/step1-25fa0769aa4c3a8dfcdf27f3b0429c11.svg";